

import { useContext } from "react";
import { useQuery } from "react-query";
import { AuthContext } from "../../../../Context/AuthContext";

const GetVehicleById = (id) => {
  const { token } = useContext(AuthContext);

  const fetchVehicle = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/vehicles/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Failed to fetch vehicle");
    }

    return response.json();
  };

  const { data, isLoading, isError } = useQuery(["vehiclesDetails", id], fetchVehicle); 

  return { data, isLoading, isError }; 
};

export default GetVehicleById;

